export const finspheraTypography = {
  fontSize: {
    xSmall: '0.625rem',
    small: '0.75rem',
    medium: '1rem',
    large: '1.25rem',
    xLarge: '1.5rem',
    xxLarge: '2rem',
    xxxLarge: '3rem'
  }
};
